"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/MiniListing.css") : void 0;
var _index = require("../utils/index");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // can remove with triplink-app-flags cleanup
var MiniListing = function MiniListing(_ref) {
  var listing = _ref.listing,
    shouldLoadImage = _ref.shouldLoadImage,
    isLoggedIn = _ref.isLoggedIn,
    _ref$betas = _ref.betas,
    betas = _ref$betas === void 0 ? {
      pathname: _config.default.nui.baseUrl
    } : _ref$betas;
  var miniImage = listing.images.miniImage,
    _listing$localized = listing.localized,
    name = _listing$localized.name,
    title = _listing$localized.title,
    _listing$core = listing.core,
    isUserConnected = _listing$core.isUserConnected,
    icon = _listing$core.icon,
    isTriplinkPreferredApp = _listing$core.isTriplinkPreferredApp,
    categories = _listing$core.categories;

  // using hasLoadedImage to be the condition of using miniImage as image src prevents the listing from swapping back and forth between default & actual image
  // this prevents unnecessary additional api calls, even if those api calls are to disk
  // also guarantees # of image api calls to be O(n) where n = # of listings
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasLoadedImage = _useState2[0],
    setHasLoadedImage = _useState2[1];
  (0, _react.useEffect)(function () {
    if (shouldLoadImage && !hasLoadedImage) {
      // case first instance where shouldLoadImage is true. Therefore we need to update hasLoadedImage so that we actually start using miniImage as image src
      // in subsequent states where the value of shouldLoadImage may change, it will not impact the value of hasLoadedImage, because it's already set to true during the first shouldLoadImage state update
      setHasLoadedImage(true);
    }
  }, [shouldLoadImage]);

  /** Note: an app can NEVER BE BOTH a triplink and endorsed app at the same time (confirmed by Laurel) */
  var renderLegacyTripLinkPreferredAppLogo = function renderLegacyTripLinkPreferredAppLogo() {
    if ((0, _index.canAccessBeta)(betas, 'triplink-app-flags') && isTriplinkPreferredApp) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "preferred"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "preferred-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "Preferred"
      })));
    }
  };
  var renderEndorsedAppLogo = function renderEndorsedAppLogo() {
    if ((categories || []).includes('ENDORSED_APPS') && ((0, _index.canAccessBeta)(betas, 'endorsed-apps-category') || _config.default.nui.endorsedCategoryEnabled)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "endorsed"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "endorsed-hover-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "EndorsedHover"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "endorsed-text"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "EndorsedApp"
      })));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mini-listing"
  }, renderLegacyTripLinkPreferredAppLogo(), renderEndorsedAppLogo(), /*#__PURE__*/_react.default.createElement("img", {
    src: (icon || miniImage) && hasLoadedImage ? icon || miniImage : '/static/images/brand/logo-SAPConcur-20171204.svg',
    className: "card-image",
    alt: "".concat(name, " icon")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text card-title"
  }, name), !isUserConnected ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text card-headline"
  }, title) : null, isLoggedIn && isUserConnected ? /*#__PURE__*/_react.default.createElement("span", {
    className: "is-connected-check"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "is-connected-check-details icon-check icon-size-sm"
  }), "\xA0", /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connected"
  })) : null);
};
MiniListing.propTypes = {
  listing: _propTypes.default.object.isRequired,
  isLoggedIn: _propTypes.default.bool,
  betas: _propTypes.default.object
};
var _default = exports.default = MiniListing;